import { RuntimeRecoveryGlobalApi, RuntimeRecoveryWindow } from './runtime-recovery.interfaces';
import { RuntimeRecoveryReason } from './runtime-recovery.types';
import { shouldSkipRuntimeRecoveryFallback } from '@lentau/core/runtime-recovery/shared/runtime-recovery-skip.utils';
import { isUserAgentSearchBot } from '@lentau/ui-kit/core/tokens/is-search-bot';

function getRuntimeRecoveryApi(): RuntimeRecoveryGlobalApi | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const globalWindow: RuntimeRecoveryWindow = window as RuntimeRecoveryWindow;
  const rawApi: unknown = globalWindow.__luRuntimeRecovery;
  if (!rawApi || typeof rawApi !== 'object') {
    return null;
  }

  const recover: unknown = (rawApi as Record<string, unknown>).recover;
  const showFallback: unknown = (rawApi as Record<string, unknown>).showFallback;
  if (typeof recover !== 'function' || typeof showFallback !== 'function') {
    return null;
  }

  return {
    recover: recover as RuntimeRecoveryGlobalApi['recover'],
    showFallback: showFallback as RuntimeRecoveryGlobalApi['showFallback'],
  };
}

export function recoverFromBootstrapError(error: unknown): void {
  const userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (userAgent && isUserAgentSearchBot(userAgent)) {
    return;
  }

  if (typeof window !== 'undefined' && shouldSkipRuntimeRecoveryFallback(window, document)) {
    return;
  }

  const runtimeRecoveryApi: RuntimeRecoveryGlobalApi | null = getRuntimeRecoveryApi();
  if (runtimeRecoveryApi === null) {
    console.error(error);
    return;
  }

  const reason: RuntimeRecoveryReason = 'bootstrap_error';
  const isRecovered: boolean = runtimeRecoveryApi.recover(reason, { error });
  if (!isRecovered) {
    runtimeRecoveryApi.showFallback(reason);
  }
}
